import React from "react";
import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import {
  LayoutDashboard, Home, Inbox, ClipboardCheck, Radio, Settings, ScrollText, LogOut, BarChart3, Star,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import logoLight from "@/assets/logo-light.png";

const NAV = [
  { to: "/admin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/analytics", icon: BarChart3, label: "Analytics & ROI" },
  { to: "/admin/apartments", icon: Home, label: "Appartamenti" },
  { to: "/admin/bookings", icon: Inbox, label: "Richieste" },
  { to: "/admin/checkins", icon: ClipboardCheck, label: "Check-in" },
  { to: "/admin/reviews", icon: Star, label: "Recensioni" },
  { to: "/admin/ota", icon: Radio, label: "Channel Manager" },
  { to: "/admin/settings", icon: Settings, label: "Impostazioni" },
  { to: "/admin/logs", icon: ScrollText, label: "Log attività" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user === null) return <div className="min-h-screen bg-petrol flex items-center justify-center text-white/70">Caricamento...</div>;
  if (user === false) return <Navigate to="/admin" replace />;

  return (
    <div className="min-h-screen bg-cream flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-64 bg-petrol text-white flex flex-col fixed h-screen">
        <div className="p-6 border-b border-white/10 flex flex-col items-start gap-2">
          <img src={logoLight} alt="Fiorucci Apartments" className="h-16 w-auto" />
          <span className="overline text-gold text-[10px]">Area Admin</span>
        </div>
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          {NAV.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={`admin-nav-${to.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-sm text-sm transition-all ${
                  isActive ? "bg-white/10 text-white" : "text-white/65 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <Icon size={18} strokeWidth={1.5} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <button
            onClick={() => { logout(); navigate("/admin"); }}
            data-testid="admin-logout"
            className="flex items-center gap-3 px-4 py-3 rounded-sm text-sm text-white/65 hover:text-white hover:bg-white/5 w-full transition-all"
          >
            <LogOut size={18} strokeWidth={1.5} /> Esci
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-64 p-8 md:p-12">
        <Outlet />
      </main>
    </div>
  );
}
